import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { VendorService } from '../../../../app/_services/vendor.services';
import { SnackbarService } from '../../../_service/message-service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/shared/interfaces/table-column';
import { TableBtn } from 'src/app/shared/interfaces/table-btn';
import { VendorListData } from './vendor-view.model';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/_services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { ManageMappingService } from '../../user-management/services/manage-mapping.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { ActualRole, Role } from 'src/app/util/enums/role.enum';
import { ActivationStatus } from '../../Station/station-details/device-spec/status.enum';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
  selector: 'telio-vendor-view',
  templateUrl: './vendor-view.component.html',
  styleUrls: ['./vendor-view.component.scss']
})
export class VendorViewComponent implements OnInit {

  userid: any;
  columns: TableColumn[];
  buttons: TableBtn[];
  vendorlist: VendorListData[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  actionFeatureLabel: string = '';
  @Input() actions = '';
  @Output() actionClicked = new EventEmitter();
  @Input() actionFeatureFlag = false;
  @Input() enableCheckbox = false;
  // @Input() enableTitle = true;
  groupHierarchyList = [];
  groupTypeFlag = false;
  selectedType: string = this.groupHierarchyList[0];

  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  checkedValues = [];
  prefCountry = '';
  defaultCountryData = {
    "country": "IN",
    "country_description": "India",
  };
  @ViewChild('credentialmanagement', { static: false }) credentialmanagement: TemplateRef<any>;
  changepasswordId;
  sendEmailCheckbox = true

  constructor(
    private vendorservice: VendorService,
    private router: Router,
    private toastr: SnackbarService,
    private userInfoService: UserInfoService,
    readonly route: ActivatedRoute,
    public loaderService: LoaderService,
    readonly translate: TranslateService,
    public dialog: MatDialog,
    readonly userService: UserService,
    readonly manageMappingService: ManageMappingService,
    readonly breadcrumbService: BreadcrumbService
  ) {

    this.userid = this.userInfoService.userDetails.userId;
    this.actionFeatureLabel = this.userInfoService.isAdminGroup() ? 'cpoList.addCpo' : 'cpoList.subCpo'

    //Mani
    this.columns = [
      { columnDef: 'username', header: 'cpoList.cpoName', cell: (element: VendorListData) => `${element.username}`, sortingDisabled: false, width: 'auto', isLink: this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) },
      { columnDef: 'email', header: 'cpoList.email', cell: (element: VendorListData) => `${element.email}`, sortingDisabled: false, width: 'auto' },
      { columnDef: 'organizationName', header: 'tenantForm.orgName', cell: (element: VendorListData) => `${element.organizationName}`, sortingDisabled: false, width: '250px', caseSensitive: 'uppercase' },
      { columnDef: 'chargeboxCount', header: 'cpoList.stnCount', cell: (element: VendorListData) => `${element.chargeboxCount}`, sortingDisabled: false, width: '120px', caseSensitive: 'uppercase', align: 'right', headerAlign: true },
      { columnDef: 'mobile', header: 'cpoList.mobile', cell: (element: VendorListData) => `${element.mobile}`, sortingDisabled: false, width: '120px' },
      { columnDef: 'status', header: 'cpoList.status', cell: (element: VendorListData) => `${element.status}`, sortingDisabled: false, width: '120px', caseSensitive: 'uppercase' },
      // { columnDef: 'group_name', header: 'rbac.groupType', cell: (element: VendorListData) => `${element.group}`, sortingDisabled: false, width: '250px', caseSensitive: 'uppercase' }
    ];


    this.actionHeader = 'actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
  }

  ngOnInit() {
    this.prefCountry = !!this.userInfoService.userDetails.prefCountry ? this.userInfoService.userDetails.prefCountry : this.defaultCountryData.country
    if (this.actions == 'roleAssign') {
      this.buttons = [
        { styleClass: 'submit', icon: 'edit', payload: (element: VendorListData) => `${element.email}`, action: 'roleAssign', tooltip: 'Assign Role', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      ];
    } else if (this.actions == 'groupAssign') {
      this.buttons = [
        { styleClass: 'submit', icon: 'edit', payload: (element: VendorListData) => `${element.email}`, action: 'groupAssign', tooltip: 'Assign Group', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      ];
    } else {
      const buttons = this.buttons = [
        { styleClass: 'submit', icon: 'edit', payload: (element: VendorListData) => `${element.email}`, action: 'edit', tooltip: 'faq.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
        { styleClass: 'submit', icon: '360', payload: (element: VendorListData) => `${element.email}`, action: 'delete', tooltip: 'stationList.changeStatus', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
        { styleClass: 'submit', icon: 'edit', payload: (element: VendorListData) => `${element.email}`, action: 'manage', tooltip: 'gst.manageGst', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE), hide: (element: VendorListData) => `${!element.checkCondition}` },
      ];
      if (this.userInfoService.isAdminGroup()) {
        buttons.push({ styleClass: 'submit', icon: '360', payload: (element: VendorListData) => `${element.userId}`, action: 'assign', tooltip: 'header.changePassword', hide: (element: VendorListData) => `${element.group.toLowerCase().includes(Role.SUPERADMIN) || element.group.toLowerCase().includes(Role.ADMIN)}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) })
      }
    }

    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);

    const cpoGroup = [ActualRole.CPO, ActualRole.SUBCPO];
    this.groupHierarchyList = this.userInfoService.isAdminGroup() ? cpoGroup : [cpoGroup[1]];
    this.groupTypeFlag = this.userInfoService.isAdminGroup();
    this.rerender(this.pageList, '');
  }

  // get vendor list
  getvendorlist(value: any, searchFilter: string = '', userType = this.groupHierarchyList[0]) {
    this.manageMappingService.getUserByGroup(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter, userType)
      .subscribe((resp: any) => {
        this.vendorlist = resp.content;
        this.totalDataCount = resp.total_items;
        this.vendorlist.map((event: any, i: number) => {
          let empty = 'NA';
          event.id = i;
          event.userId = !!event.user_id ? event.user_id : empty;
          event.username = !!event.username ? event.username : empty;
          event.email = !!event.user_email ? event.user_email : empty;
          event.mobile = !!event.mobile ? event.mobile : empty;
          event.status = !!event.status ? event.status.toUpperCase() : empty;
          event.parent_id = !!event.parent_id ? event.parent_id : empty;
          event.group = !!event.group_name ? event.group_name : empty;
          event.organizationName = !!event.organization_name ? event.organization_name : empty;
          event.chargeboxCount = !!event.chargebox_count ? event.chargebox_count : 0;
          event.checkCondition = this.prefCountry == 'IN'
          event.disableAssign = event.country=='IN' ? false : true;
        })
      },
    err=>{
      this.toastr.error(err.message);
    });
  }

  buttonClick(result: string[]) {
    if (result[0] == 'delete') {
      let item = this.vendorlist.find(res => res.email == result[1])
      this.deactivateOperator(item);
    } else if ((result[0] == 'edit')) {
      let item = this.vendorlist.find(res => res.email == result[1])
      this.editVendor(item, result[1]);
    } else if (result[0] == 'view') {
      let item = this.vendorlist.find(res => res.email == result[1])
      this.vendorclick(result[1]);
    }
    else if (result[0] == 'manage') {
      let item = this.vendorlist.find(res => res.email == result[1])
      this.vendornavigate(item, result[1]);
    }
    else if (result[0] == 'roleAssign' || result[0] == 'groupAssign') {
      let item = this.vendorlist.find(res => res.email == result[1])
      this.actionClicked.emit({ 'action': result[0] == 'roleAssign' ? 'roleAssign' : 'groupAssign', 'userId': item.userId, 'username': item.username })
    } else if (result[0] == 'assign') {
      this.credentialManagement()
      this.changepasswordId = result[1];
    }
  }

  actionClick(event) {
    this.rerender(this.pageList, '', this.selectedType);
  }

  vendornavigate(vendor, email) {
    this.userService.getLanguagesbycountry().subscribe((res: any) => {
      if (!!res) {
        let filterCountries = res.map((resp: any) => resp.country.toLowerCase());

        let selectedvendor = JSON.stringify(vendor.user);
        let objToSend: NavigationExtras = {
          queryParams: {
            "station": selectedvendor,
            "vendorId": email,
            "editvendor": true,
            "userId": vendor.userId,
            "mappingTab": false,
            "routedName": "operators",
            "groupType": vendor.group,
            listedCountries: filterCountries,
            "fromGST": true,
          },
          skipLocationChange: true
        };

        this.router.navigate(["/dashboard/charge-point-operators", { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
        this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGE_POINT_OPERATOR_UPDATE);
      }
    })
  }

  vendorclick(id, userId?, group?) {
    this.router.navigate(['/dashboard/operators/details', { routeID: this.route.snapshot.paramMap.get('routeID') }], { queryParams: { "vendorid": JSON.stringify(id), "userId": userId, index: '0', "mappingTab": false, "groupType": group, routedName: 'chargePointOperators' }, skipLocationChange: true })
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGE_POINT_OPERATOR_OPERATOR);
  }

  // Edit Vendor
  editVendor(vendor, email) {
    this.userService.getLanguagesbycountry().subscribe((res: any) => {
      if (!!res) {
        let filterCountries = res.map((resp: any) => resp.country.toLowerCase());

        let selectedvendor = JSON.stringify(vendor.user);
        let objToSend: NavigationExtras = {
          queryParams: {
            "station": selectedvendor,
            "vendorId": email,
            "editvendor": true,
            "userId": vendor.userId,
            "mappingTab": false,
            "routedName": "operators",
            "groupType": vendor.group,
            listedCountries: filterCountries,
          },
          skipLocationChange: true
        };

        this.router.navigate(["/dashboard/charge-point-operators", { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
        this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGE_POINT_OPERATOR_UPDATE);
      }
    })
  }

  deletevendorbyid(deleteid, status, username) {
    let changeStatus = status.toLowerCase() == ActivationStatus.ACTIVE.toLowerCase() ? ActivationStatus.INACTIVE : ActivationStatus.ACTIVE;
    let input: any = {
      "status": changeStatus,
      "vendor_id": deleteid,
      "name": username
    }
    this.vendorservice.changeStatusCpo(input).subscribe(
      (resp: any) => {
        if (!!resp) {
          this.toastr.success(resp);
          this.rerender(this.pageList, '', this.groupHierarchyList);
        }
        else {
          this.toastr.error(this.translate.instant('failedStatus'));
        }
      }
    );
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData, this.selectedType)
  }

  rerender(value: any, searchFilter?: string, userType = this.groupHierarchyList[0]): void {
    this.getvendorlist(value, searchFilter, userType);
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '', this.selectedType)
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '', this.selectedType);
  }

  linkClick(event) {
    if (event.column.columnDef == "username") {
      this.vendorclick(event.row.email, event.row.userId, event.row.group);
    }
  }

  deactivateOperator(item: any): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: item.status.toLowerCase() == 'inactive' ? this.translate.instant('cmsUsers.statusActivate', { user: item.email }) : this.translate.instant('cmsUsers.statusDeactivate', { user: item.email }) }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deletevendorbyid(item.email, item.status, item.username);
      }
    });
  }

  actionFeature(event: any) {
    if (this.actions && this.actions.length > 1) {
      let userList: any = [];
      userList = this.checkedValues.map(res => res.userId);
      this.actionClicked.emit({ 'action': this.actions, 'userId': userList });
    } else {
      this.userService.getLanguagesbycountry().subscribe((res: any) => {
        if (!!res) {
          let filterCountries = res.map((resp: any) => resp.country.toLowerCase());

          let objToSend: NavigationExtras = {
            queryParams: {
              listedCountries: filterCountries,
              "routedName": "operators",
            },
            skipLocationChange: true
          };
          this.router.navigate(['/dashboard/charge-point-operators', { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
          this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGE_POINT_OPERATOR_CREATE)
        }
      })
    }
  }


  checkedRow(event: any) {
    if (event.length > 1) {
      this.checkedValues = event;
      this.actionFeatureFlag = true;
      this.actionFeatureLabel = this.actions == 'roleAssign' ? 'rbac.assignRole' : 'rbac.assignGroup';
    } else {
      this.actionFeatureFlag = false;
    }
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  selectionChange(event: any) {
    this.selectedType = event;
    this.getvendorlist(this.pageList, '', event);
  }

  credentialManagement() {
    let dialogRef = this.dialog.open(this.credentialmanagement, {
      width: '40vw',
      height: '29vh',
    }).afterClosed()
  }

  submitCredentials() {
    const id = this.changepasswordId;
    let headers = { headers: { 'Accept-Version': 'V2','is_check': String(this.sendEmailCheckbox),'X-Tenant-ID': this.userInfoService.userDetails.tenantID  } }
    let input = {
      'is_check': this.sendEmailCheckbox
    }
    this.userService.submitCredentials(id, headers, input).subscribe(((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('wallets.walletSuccess'))
        this.closeDialogue()
      } else {
        this.toastr.error(this.translate.instant('responseFailed'))
        this.closeDialogue()
      }
    }), err => {
      this.toastr.error(err.message);
    })
  }

  closeDialogue() {
    this.dialog.closeAll();
    this.sendEmailCheckbox = true;
  }

  updateSendEmailCheckbox(event) {
    this.sendEmailCheckbox = event.checked;
  }
}
